<template>
  <div>
    <div
      class="z-50 leading-normal text-gray-600"
      :class="enableSqueeze ? 'basketSqueeze' : 'basket'"
    >
      <div class="overflow-hidden border border-b-0 bg-white shadow-lg md:rounded-lg">
        <div
          class="border-b p-2 px-3 tracking-wide"
          style="
            background: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(240, 240, 240, 1));
          "
        >
          Basket
        </div>

        <div>
          <div
            v-if="basket === null || basket === undefined"
            class="p-3 text-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="shopping-basket"
              role="img"
              viewBox="0 0 576 512"
              class="mx-auto h-12 w-12"
            >
              <path
                fill="currentColor"
                d="M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
              />
            </svg>
            <h3 class="mt-2 text-sm font-medium text-gray-900">
              Basket empty
            </h3>
          </div>

          <div v-else>
            <div class="p-3">
              <div class="border-b pb-4">
                <div class="mt-2 flex justify-between tracking-wide text-gray-900">
                  <div
                    v-if="basket.PackageType === 0"
                    id="packageDuration"
                  >
                    12 Month Package
                  </div>
                  <div v-if="basket.PackageType === 1">
                    {{ basket.NewHomePoints }} <span v-if="false">Home </span>Points
                  </div>
                  <div v-if="basket.PackageType === 2">
                    {{ basket.NewAwayPoints }} Flexi Points
                  </div>
                  <div v-if="basket.PackageType === 5">
                    {{ basket.LessonCredits || 0 }} {{ basket.LessonCredits === 1 ? 'Lesson' : 'Lessons' }}
                  </div>

                  <div id="cost">
                    {{ basket.Currency.CurrencySymbol }}{{ totalWithInsurance.toLocaleString() }}
                  </div>
                </div>

                <div class="flex justify-between text-sm leading-tight text-gray-600">
                  <div v-if="basket.PackageType === 0">
                    Valid until
                    {{
                      $moment(basket.MembershipExtension.ExtendedRenewalDate).format(
                        'Do MMMM YYYY'
                      )
                    }}.
                  </div>
                  <div v-if="basket.PackageType === 1">
                    Additional <span v-if="false">Home </span>points can be spent on rounds of golf
                    at your home club.
                  </div>
                  <div v-if="basket.PackageType === 2">
                    Additional Flexi Points can be spent on rounds of golf at your home club and any
                    other club in the network.
                  </div>
                  <div v-if="basket.PackageType === 5">
                    Lesson credits can be used for golf lessons at your club.
                  </div>
                </div>
              </div>

              <div
                v-if="!disabledAccount"
                id="checkout"
                class="brand-button mt-4"
                @click="checkout()"
              >
                Checkout
              </div>

              <div
                class="brand-button-secondary mt-2"
                @click="emptyBasket()"
              >
                Empty Basket
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { calculateTotalWithInsurance } from '@/app/shared/utils/insuranceCalculator';
import ClubItemModel from '@/app/shared/events/models/clubItemModel';
import { services } from '@/app/shared/services';

export default {
  components: {},

  props: {
    enableSqueeze: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      refreshingBasket: false,
      disabledAccount: false,
    };
  },

  computed: {
    ...mapState({
      basket: state => state.basket.basket,
      donation: state => state.basket.donation,
      homeClubId: state => state.user.homeClubId,
      userGuid: state => state.user.userGuid,
    }),

    // Add insurance cost to total (only for Type 7 extras)
    totalWithInsurance() {
      const total = calculateTotalWithInsurance(this.basket);
      return total + this.donation.amount;
    },

    ...mapGetters({
      getMemberExpiryInfo: 'getMemberExpiryInfo',
    }),
  },

  mounted() {
    this.isDisabledAccount();
    if (this.basket !== null) {
      this.$event.viewCart(
        this.basket.NewPrice,
        new ClubItemModel(
          this.basket.NewClubId === null ? this.homeClubId : this.basket.NewClubId,
          this.basket.NewPrice,
        ),
      );
    }
  },

  methods: {

    isDisabledAccount() {
      services.member.memberSummary().then((dataMember) => {
        services.member.getDisabledReason(this.userGuid).then((data) => {
          if (data !== null && data.AuditData !== null) {
            if (JSON.parse(data.AuditData).Action === 'Disabled' && JSON.parse(data.AuditData).Reason != null && !dataMember.IsActive) {
              this.disabledAccount = true;
            } else {
              this.disabledAccount = false;
            }
          } else {
            this.disabledAccount = false;
          }
        });
      });
    },
    checkout() {
      // if they were expired they wouldn't have home points theoretically, hence this only looks at suspension period
      // though maybe it should do unexpired members too at some point?
      if (
        this.homeClubId !== this.basket.NewClubId
        && this.basket.NewClubId !== null
        && (this.getMemberExpiryInfo.inSuspensionPeriod() || !this.getMemberExpiryInfo.isExpired())
      ) {
        this.$router.push({ name: 'checkoutTransfer', params: { type: 'full' } });
      } else {
        this.$router.push({ name: 'checkoutBasket' });
      }
      this.$store.dispatch('setBasketMenuState', false);
    },

    emptyBasket() {
      this.refreshingBasket = true;
      const basket = this.basket;
      this.$store.dispatch('emptyBasket').then(() => {
        this.refreshingBasket = false;
        this.$event.removeCart(
          basket.NewPrice,
          new ClubItemModel(
            basket.NewClubId === null ? this.homeClubId : basket.NewClubId,
            basket.NewPrice,
          ),
        );
      });
    },
  },
};
</script>

<style>
@media (min-width: 768px) {
  .basket {
    position: absolute;
    top: 35px;
    right: -51px;
    width: 380px;
  }

  .basket:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    color: transparent;
    border: 10px solid rgb(0, 0, 0);
    border-color: transparent transparent #e2e8f0;
    margin-left: 300px;
    margin-top: -5px;
  }
}

@media (max-width: 768px) {
  .basket {
    position: fixed;
    top: 60px;
    left: 0px;
    width: 100vw;
  }

  .basket:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    color: transparent;
    border: 10px solid rgb(0, 0, 0);
    border-color: transparent transparent transparent;
    margin-left: 136px;
    margin-top: -20px;
  }
}

@media (min-width: 768px) {
  .basketSqueeze {
    position: absolute;
    top: 47px;
    right: -60px;
    width: 380px;
  }

  .basketSqueeze:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    color: transparent;
    border: 10px solid rgb(0, 0, 0);
    border-color: transparent transparent #e2e8f0;
    margin-left: 300px;
    margin-top: -5px;
  }
}

@media (max-width: 768px) {
  .basketSqueeze {
    position: fixed;
    top: 60px;
    left: 0px;
    width: 100vw;
  }
}
</style>
